import { useMemo } from "react";
import { useSelector } from "react-redux";

export function useEnsureInstall() {
  const installState = useSelector((state) => state.install);

  const isReady = useMemo(() => {
    return (
      installState.checked &&
      installState.installData !== null &&
      (installState.success || (installState.shop !== null && installState.shop !== undefined))
    );
  }, [installState.checked, installState.installData, installState.success, installState.shop]);

  return useMemo(
    () => ({
      installChecked: installState.checked,
      installSuccess: installState.success,
      installLoading: installState.loading,
      isRedirecting: installState.redirecting,
      installError: installState.error,
      installData: installState.installData,
      shop: installState.shop,
      host: installState.host,
      isReady,
    }),
    [
      installState.checked,
      installState.success,
      installState.loading,
      installState.redirecting,
      installState.error,
      installState.installData,
      installState.shop,
      installState.host,
      isReady,
    ],
  );
}
